import { sendGoogleEvent } from '@html/_common/utils';

const EVENT_CATEGORY = 'CLP - ';
const LINK_CLASS = '.js-ao-clp-specials-and-news__link';

export default function AOClpSpecialsAndNews() {
  const initiate = () => {
    const $anchorLink = $(LINK_CLASS);

    $anchorLink.on('click', (event) => {
      const linkHref = $(event.currentTarget).attr('href');
      const isAbsoluteLink = linkHref.indexOf('https://') === 0 || linkHref.indexOf('http://') === 0;

      const googleSendEventLink = (isAbsoluteLink) ? linkHref : `${window.location.protocol}//${window.location.host}${linkHref}`;

      sendGoogleEvent(
        `${EVENT_CATEGORY}Special & News`,
        'Click',
        googleSendEventLink,
        {
          transport: 'beacon',
        },
      );
    });
  };

  return { initiate };
}
